import { setCustomAvatar, clearCustomAvatar } from "./getAvatar";

function hydrateOne(user) {
  if (!user || typeof user.get !== "function") return;
  const username = user.get("username");
  if (!username) return;
  const pixels = user.get("avatarPixels");
  if (pixels) {
    setCustomAvatar(username, pixels);
  } else {
    // Server may have unset avatarPixels (all-zero clear); drop any stale
    // cache entry so subsequent renders fall back to the identicon.
    clearCustomAvatar(username);
  }
}

export function hydrateAvatars(input) {
  if (!input) return;
  if (Array.isArray(input)) {
    for (const u of input) hydrateOne(u);
    return;
  }
  hydrateOne(input);
}
